/**
 * Утилита для работы с временными заказами в localStorage
 * Используется для сохранения заказов неавторизованных пользователей
 */

const PENDING_CART_KEY = 'pending_cart_items';
const SESSION_ID_KEY = 'guest_session_id';

/**
 * Получить или создать session_id для гостя
 * @returns {string}
 */
export const getGuestSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  return sessionId;
};

/** Текущий guest session_id без создания нового (для слияния корзины после логина) */
export const getExistingGuestSessionId = () => localStorage.getItem(SESSION_ID_KEY);

/**
 * Очистить session_id
 */
export const clearGuestSessionId = () => {
  localStorage.removeItem(SESSION_ID_KEY);
};

/**
 * Сохранить товар во временную корзину
 * @param {string} productId - ID продукта
 * @param {Object} calculatorData - Данные калькулятора
 * @returns {void}
 */
export const savePendingCartItem = (productId, calculatorData) => {
  try {
    const existingItems = getPendingCartItems();
    const newItem = {
      productId,
      calculatorData,
      timestamp: Date.now()
    };
    
    // Проверяем, нет ли уже такого товара
    const existingIndex = existingItems.findIndex(item => item.productId === productId);
    
    if (existingIndex >= 0) {
      // Обновляем существующий товар
      existingItems[existingIndex] = newItem;
    } else {
      // Добавляем новый товар
      existingItems.push(newItem);
    }
    
    localStorage.setItem(PENDING_CART_KEY, JSON.stringify(existingItems));
  } catch (error) {
    console.error('Error saving pending cart item:', error);
  }
};

/**
 * Получить все товары из временной корзины
 * @returns {Array} Массив товаров
 */
export const getPendingCartItems = () => {
  try {
    const items = localStorage.getItem(PENDING_CART_KEY);
    return items ? JSON.parse(items) : [];
  } catch (error) {
    console.error('Error getting pending cart items:', error);
    return [];
  }
};

/**
 * Удалить товар из временной корзины
 * @param {string} productId - ID продукта
 * @returns {void}
 */
export const removePendingCartItem = (productId) => {
  try {
    const existingItems = getPendingCartItems();
    const filteredItems = existingItems.filter(item => item.productId !== productId);
    localStorage.setItem(PENDING_CART_KEY, JSON.stringify(filteredItems));
  } catch (error) {
    console.error('Error removing pending cart item:', error);
  }
};

/**
 * Очистить всю временную корзину
 * @returns {void}
 */
export const clearPendingCart = () => {
  try {
    localStorage.removeItem(PENDING_CART_KEY);
  } catch (error) {
    console.error('Error clearing pending cart:', error);
  }
};

/**
 * Уведомить об изменении корзины (для обновления Header)
 */
export const dispatchCartUpdate = () => {
  window.dispatchEvent(new CustomEvent('cart-updated'));
};
